// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"f82eb1a4","2294":"8342a124","4167":"9dbf2faf","6128":"9dbf2faf","8394":"78494deb"}[chunkId] + ".chunk.css";
};